<template>
  <div
    v-if="appointment"
    class="container mt-3"
  >
    <AppointmentDetailComponent
      :appointment="appointment"
      @update="getAppointment"
    />

    <div
      v-if="isAgent"
    >
      <Toolbar>
        <template #start>
          <h2>{{ $t('entity.barcode.list') }}</h2>
        </template>
        <template #end>
          <Button
            class="p-button-rounded p-button-outlined"
            icon="pi pi-plus"
            :label="$t('action.crud.create')"
            @click="showCreatebarcodeForm = true"
          />
        </template>
      </Toolbar>

      <BarcodeTable
        v-model:sortField="barcodeFilter.pageable.sortField"
        v-model:sortOrder="barcodeFilter.pageable.sortOrder"
        v-model:filters="barcodeFilter.filters"
        v-model:rows="barcodeFilter.pageable.size"
        paginator-position="both"
        :paginator="true"
        :value="barcodes"
        :show-edit-button="true"
        :total-records="totalItemsCount"
        @sort="getBarcodes()"
        @filter="getBarcodes()"
        @page="onPageChange($event)"
        @delete="getBarcodes()"
        @update-appointment="getAppointment()"
      />

      <BarcodeCreateDialog
        v-model:visible="showCreatebarcodeForm"
        :appointment="appointment"
        :stakeholder="appointment.request.user.stakeholder"
        @create="getBarcodes"
      />
    </div>
  </div>
</template>

<script>
import AppointmentDetailComponent from "@/components/appointments/AppointmentDetailComponent";
import {CONTACT_ROLE} from "@/shared/constants";
import BarcodeTable from "@/components/barcodes/BarcodeTable";
import useBarcodeFilter from "@/composables/filters/useBarcodeFilter";
import {computed, reactive} from "vue";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import BarcodeCreateDialog from "@/components/barcodes/BarcodeCreateDialog.vue";

export default {
  name: 'AppointmentDetailView',
  components: {
    BarcodeCreateDialog,
    AppointmentDetailComponent,
    BarcodeTable,
    Button,
    Toolbar
  },
  provide() {
    return {
      stakeholderId: computed(() => this.appointment?.request.user.stakeholder.id),
      appointmentId: computed(() => this.appointment.id)
    }
  },
  setup() {
    const barcodeFilter = reactive(useBarcodeFilter());
    return {
      barcodeFilter
    }
  },
  data() {
    return {
      appointment: null,
      barcodes: [],
      totalItemsCount: 0,

      showCreatebarcodeForm: false,
    }
  },
  computed: {
    isAgent() {
      return this.$store.state.auth.user.role !== CONTACT_ROLE;
    },
  },
  async mounted() {
    await this.getAppointment()
    if(this.isAgent){
      this.barcodeFilter.filters.stakeholder.value = this.appointment.request.user.stakeholder.id;
      this.barcodeFilter.pageable.sortField = 'start';
      this.barcodeFilter.filters.deleted.value = false;
      await this.getBarcodes();
    }
  },
  methods: {
    async getAppointment() {
      try {
        this.appointment = await this.$appointmentService.fetchById(this.$route.params.id);
      } catch (e) {
        console.error(e);
        await this.$router.push('/');
      }
    },
    onPageChange(event) {
      this.barcodeFilter.pageable.page = event.page;
      this.getBarcodes();
    },
    async getBarcodes() {
      const params = this.barcodeFilter.getQueryParams();
      const result = await this.$barcodeService.getAll(params);
      this.barcodes = result.content;
      this.totalItemsCount = result.totalElements;
    }

  }
}
</script>

<style lang="scss" scoped>
span {
  float: right;
}
</style>
